



































































































import moment from 'moment'
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import Apis from '@/Apis/_'
import { LoteNotificacao, LoteNotificacaoDetalheItem, LoteDetalhesParams } from '@/types/interfaces/LoteNotificacao'

@Component
export default class ModalNotificacaoEmailDetalhes extends Vue {
  @Prop({ type: Boolean, default: false }) visible!: boolean
  @Prop({ type: Object, default: () => null }) lote!: LoteNotificacao | null

  @Emit('close')
  close() { }

  detalhesItens: LoteNotificacaoDetalheItem[] = []
  detalhesTotalCount: number = 0
  loadingDetalhes: boolean = false
  loadingExportExcel: boolean = false
  filtroDetalhes: any = null
  detalhesPagination: any = { page: 1, rowsPerPage: 10, totalItems: 0 }
  paginacaoCarregada: string = ''
  consultaDetalhes: number = 0

  detalhesHeaders: any[] = [
    { text: 'Status', value: 'sucesso', align: 'center', sortable: false, width: '80px' },
    { text: 'Prestador', value: 'prestadorNome', align: 'left', sortable: false },
    { text: 'Empresa', value: 'empresaMedicaNome', align: 'left', sortable: false },
    { text: 'Repasse', value: 'numeroRepasse', align: 'center', sortable: false },
    { text: 'Valor (R$)', value: 'valorNota', align: 'right', sortable: false },
    { text: 'Destinatários', value: 'destinatarios', align: 'left', sortable: false },
    { text: 'Data', value: 'createdOn', align: 'center', sortable: false },
    { text: 'Erro', value: 'log', align: 'left', sortable: false },
  ]

  get getFinanceiroStore() { return getModule(FinanceiroStore, this.$store) }

  @Watch('visible')
  async onVisibleChanged(val: boolean) {
    if (!val || !this.lote) {
      return
    }

    this.detalhesItens = []
    this.detalhesTotalCount = 0

    this.detalhesPagination.page = 1

    if (this.filtroDetalhes !== null) {
      this.filtroDetalhes = null
      return
    }

    await this.loadDetalhes()
  }

  async loadDetalhes() {
    const { lote } = this
    if (!lote) return

    this.paginacaoCarregada = `${this.detalhesPagination.page}|${this.detalhesPagination.rowsPerPage}`
    this.loadingDetalhes = true
    const params: LoteDetalhesParams = {
      page: this.detalhesPagination.page,
      pageSize: this.detalhesPagination.rowsPerPage,
    }
    if (this.filtroDetalhes !== null && this.filtroDetalhes !== undefined) {
      params.sucesso = this.filtroDetalhes
    }

    this.consultaDetalhes += 1
    const consulta = this.consultaDetalhes
    const response = await this.getFinanceiroStore.getLoteDetalhes({ id: lote.id, params })
    if (consulta !== this.consultaDetalhes) return

    if (response.success && response.data) {
      this.detalhesItens = response.data.items || []
      this.detalhesTotalCount = response.data.totalCount || 0
    } else {
      this.detalhesItens = []
      this.detalhesTotalCount = 0
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Não foi possível carregar os detalhes do lote.', icon: 'warning', color: '#C62828' })
    }
    this.detalhesPagination.totalItems = this.detalhesTotalCount
    this.loadingDetalhes = false
  }

  @Watch('filtroDetalhes')
  onFiltroDetalhesChanged() {
    this.detalhesPagination.page = 1
    this.loadDetalhes()
  }

  @Watch('detalhesPagination', { deep: true })
  onDetalhesPaginationChanged() {
    const paginacaoAtual = `${this.detalhesPagination.page}|${this.detalhesPagination.rowsPerPage}`

    if (paginacaoAtual === this.paginacaoCarregada) {
      return
    }

    this.loadDetalhes()
  }

  async exportarRelatorioExcelDetalhes() {
    const { lote } = this
    if (!lote) return

    try {
      this.loadingExportExcel = true
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.exportarDetalhesLote(
        lote.id,
        this.filtroDetalhes,
      )
      if (!request.success) {
        EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Erro ao gerar o relatório excel.', icon: 'warning', color: '#C62828' })
        return
      }
      this.openExcel(request.data)
    } catch (e) {
      console.error(e)
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao gerar o relatório excel.', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingExportExcel = false
    }
  }

  openExcel(base64Uri: string) {
    if (!base64Uri) return
    const link = document.createElement('a')
    link.href = base64Uri

    let situacao = 'Envios'
    if (this.filtroDetalhes === true) situacao = 'Enviados'
    else if (this.filtroDetalhes === false) situacao = 'Erros'
    const datetime = moment().format('YYYYMMDD_HHmmss')
    link.download = `Relatorio_${situacao}_${datetime}.xlsx`

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  formatDestinatariosTooltip(destinatarios: string) {
    if (!destinatarios) {
      return 'Sem destinatário'
    }

    return destinatarios
      .split(';')
      .map(email => email.trim())
      .filter(email => !!email)
      .join('\n')
  }

  formatDateTimeUtil(date: string) {
    if (['', null, undefined].includes(date)) return '-'
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  formatCurrency(value: number) {
    if (value == null) return '-'
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
  }
}
